import React from 'react';
import { Box, Flex, useDisclosure } from '@chakra-ui/react';
import { HeaderMinibar } from '../HeaderMinibar/headerMinibar';
import { Menu } from '../Menu/menu';
import { Footer } from '../Footer/footer';
import { Copyright } from '../Copyright/copyright';
import { isLauncher } from '../../utils/launcher';
import { PromotionPane } from './PromotionPane/promotionPane';
import { Color } from 'src/theme/color';

export const containerMaxWXl = '1240px';

export const ContentContainer = ({
	children,
	mainColor,
	isCustomThemed = false,
}: {
	children: any;
	mainColor?: string;
	isCustomThemed?: boolean;
}) => {
	const { isOpen: isOpenMobileMenu, onOpen, onClose: onCloseMobileMenu } = useDisclosure();

	return (
		<Flex
			width="100%"
			alignItems="center"
			flexDirection="column"
			zIndex="1"
		>
			{/** Actual "header" */}
			<Box
				width="100%"
				filter={isCustomThemed ? 'grayscale(100%)' : 'unset'}
				borderBottom={{ base: '1px solid #F1F3F61A', hashup: 'none' }}
				position="sticky"
				top="0"
				left="0"
				zIndex="999"
				background={Color.BACKGROUND}
			>
				<HeaderMinibar
					onOpenMobileMenu={onOpen}
					mainColor={mainColor}
				/>
				<PromotionPane />
				{isLauncher() || (
					<Menu
						mainColor={mainColor}
						isOpenMobileMenu={isOpenMobileMenu}
						onCloseMobileMenu={onCloseMobileMenu}
					/>
				)}
			</Box>
			{/* {loading ? ( */}
			{/*	<Flex justifyContent="center" w="100%"> */}
			{/*		<Spinner /> */}
			{/*	</Flex> */}
			{/* ) : ( */}
			{children}
			<Flex
				w="100%"
				pos="relative"
			>
				<Box
					top="0"
					w={{ base: '40%', md: '30%' }}
					pos="absolute"
					borderBottom={`1px solid ${Color.ACTION}`}
					filter={isCustomThemed ? 'grayscale(100%)' : 'unset'}
				/>
			</Flex>
			<Flex
				w="100%"
				alignItems="center"
				flexDirection="column"
				px={{ md: '32px', hashup: '56px' }}
				filter={isCustomThemed ? 'grayscale(100%)' : 'unset'}
			>
				<Footer />
				<Copyright />
			</Flex>
		</Flex>
	);
};
